import { httpClient } from '@/modules/common/services/http/http-client';
import { FeeTransparencyDisclaimer } from '@/modules/trade/views/TradeView/components/FeeTransparencyDisclaimer/types';

const baseURL = `${process.env.VUE_APP_BFF_URL}/trading`;
export const httpClientWithDefaultOptions = httpClient.withOptions({ baseURL });

export function getFeeTransparencyDisclaimer(): Promise<FeeTransparencyDisclaimer> {
  return httpClientWithDefaultOptions.get('disclaimers/fee-transparency');
}
